import { getParticipantColor, getParticipantInitial } from "@/lib/participantColor";

interface Props {
  participantId: string;
  displayName?: string;
  isMe?: boolean;
  size?: "xs" | "sm" | "md";
}

const sizes = {
  xs: { box: "w-5 h-5 text-[10px]", ring: 1 },
  sm: { box: "w-7 h-7 text-xs", ring: 2 },
  md: { box: "w-9 h-9 text-sm", ring: 2 },
};

export const ParticipantBadge = ({
  participantId,
  displayName,
  isMe = false,
  size = "sm",
}: Props): JSX.Element => {
  const color = getParticipantColor(participantId);
  const initial = getParticipantInitial(participantId, displayName);
  const s = sizes[size];

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold ${s.box} ${
        isMe ? "ring-2 ring-offset-1 ring-offset-bg ring-primary/40" : ""
      }`}
      style={{ backgroundColor: color.bg, color: color.fg }}
      aria-label={isMe ? "Vous" : displayName ?? "Participant"}
      title={isMe ? "Vous" : displayName ?? participantId.slice(0, 6)}
    >
      {initial}
    </span>
  );
};
